import {Box, Center, Heading, Image, Text} from '@chakra-ui/react'
import { Reveal, Tween } from 'react-gsap';

const heart = "https://svgsilh.com/svg/307525.svg"

const Metas = () => {

    return <Box>

        <Reveal>
            <Tween from={{opacity: 0, x: "-10%"}} duration={0.5}>
                <Heading
                    textAlign="left"
                    py="2%"
                    as="h2" 
                    size="3xl"
                    color="rgb(255, 255, 255)"
                    userSelect="none"
                    fontWeight="800"
                >
                    Metas
                </Heading>
            </Tween>
        </Reveal>

        <Reveal>
            <Tween from={{opacity: 0.0, y: "25%"}}>
                <Text color="rgb(255, 255, 255)">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vel nisi nec felis ultrices efficitur. In lacus nulla, mollis feugiat malesuada eget, malesuada vel nibh. Praesent ut est ipsum. Fusce mollis orci accumsan porttitor accumsan. In aliquet lectus in ligula condimentum pulvinar. Nam vel ligula et dui posuere imperdiet in sed risus. Aenean bibendum porta lacus, quis aliquet ipsum facilisis vel. Nam rutrum nisl nec mauris lacinia, ut pretium nibh tempor. Duis luctus elit a nisi lacinia dictum. 
                </Text>
            </Tween>
        </Reveal>

        <Center
            mt="2"
        >
            <Image
                alt="test img"
                src={heart}
                width="20%"
            />
        </Center>

    </Box>
}

export default Metas